import { render, staticRenderFns } from "./AgentActionButtons.vue?vue&type=template&id=04964df0&scoped=true"
import script from "./AgentActionButtons.vue?vue&type=script&lang=js"
export * from "./AgentActionButtons.vue?vue&type=script&lang=js"
import style0 from "./AgentActionButtons.vue?vue&type=style&index=0&id=04964df0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04964df0",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QMenu,QList,QItem,QItemSection,QSeparator});qInstall(component, 'directives', {ClosePopup});
